import { createMutation, createQuery } from 'react-query-kit';

import type { BodyQuizEntryMapRes } from '@/api/gen/_model/bodyQuizEntryMapRes';
import type { GetQuizSetByEntryMapParams } from '@/api/gen/_model/getQuizSetByEntryMapParams';
import type { GetQuizSetDetailsParams } from '@/api/gen/_model/getQuizSetDetailsParams';
import type { SuccessBody } from '@/api/gen/_model/successBody';
import type { SuccessBodyQuizSetDetailsRes } from '@/api/gen/_model/successBodyQuizSetDetailsRes';
import type { SuccessBodyUploadImageRes } from '@/api/gen/_model/successBodyUploadImageRes';
import type { UploadImageBody } from '@/api/gen/_model/uploadImageBody';
import {
  getQuizSetByEntryMap,
  getQuizSetDetails,
} from '@/api/gen/quiz/quiz.gen';
import {
  AXIOS_INSTANCE,
  type BodyType,
  type httpsInstance,
} from '@/api/httpClient';

export const QUIZ_DETAIL_QUERY_KEY = ['quiz-detail'];

export const useQuizDetail = createQuery<
  SuccessBodyQuizSetDetailsRes,
  GetQuizSetDetailsParams
>({
  queryKey: QUIZ_DETAIL_QUERY_KEY,
  fetcher: ({ id }) => getQuizSetDetails({ id }),
});

export const useEnterMap = createQuery<
  BodyQuizEntryMapRes | SuccessBody,
  GetQuizSetByEntryMapParams
>({
  queryKey: ['enter-map'],
  fetcher: (variables: GetQuizSetByEntryMapParams) =>
    getQuizSetByEntryMap(variables),
});

export const MY_QUIZ_LIST_QUERY_KEY = ['my-quizes'];

export const useUploadImage = createMutation<
  SuccessBodyUploadImageRes,
  UploadImageBody & { options?: SecondParameter<typeof httpsInstance> }
>({
  mutationFn: async ({ options, ...variables }) => {
    return uploadImage(variables, options);
  },
});

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

export const uploadImage = async (
  uploadImageBody: BodyType<UploadImageBody>,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  const d = await AXIOS_INSTANCE.postForm<SuccessBodyUploadImageRes>(
    `/quizsets/image`,
    uploadImageBody,
    options,
  );
  return d.data;
};
